// extracted by mini-css-extract-plugin
export default {"headerContainer":"Navigation_headerContainer__s7YUB","logoIcon":"Navigation_logoIcon__QRTW1","header":"Navigation_header__o5Ny4","headerButton":"Navigation_headerButton__txuLC"};